import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin } from "lucide-react";
import { CONTACT, waLink } from "@/data/site";
import { WhatsAppIcon } from "@/components/Header";
import { useQuote } from "@/components/QuoteDialog";

const Col = ({ title, links }) => (
  <div>
    <h4 className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#FF5A00] mb-4">{title}</h4>
    <ul className="space-y-2.5">
      {links.map((l) => (
        <li key={l.label}>
          {l.to ? (
            <Link to={l.to} className="text-zinc-400 hover:text-white transition-colors text-[15px]">{l.label}</Link>
          ) : (
            <a href={l.href} onClick={l.onClick} target={l.href?.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" className="text-zinc-400 hover:text-white transition-colors text-[15px] cursor-pointer">{l.label}</a>
          )}
        </li>
      ))}
    </ul>
  </div>
);

const Footer = () => {
  const { openQuote } = useQuote();
  return (
    <footer className="relative bg-[#121212] text-white overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 noise-overlay opacity-[0.06] pointer-events-none" />
      <div className="relative max-w-[1440px] mx-auto px-5 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10 md:gap-8">
          <div className="col-span-2">
            <img src="/logo-axal-white.png" alt="AXAL Logistics" className="h-14 w-auto" />
            <p className="text-zinc-400 text-[15px] mt-5 max-w-xs leading-relaxed">
              Soluzioni professionali per trasporti, spedizioni e traslochi in tutta Italia.
            </p>
            <div className="flex gap-3 mt-6">
              {[Instagram, Facebook, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-zinc-300 hover:bg-[#FF5A00] hover:border-[#FF5A00] transition-colors" aria-label="social">
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>
          <Col title="Servizi" links={[
            { label: "Trasporti", to: "/trasporti" }, { label: "Traslochi", to: "/traslochi" },
            { label: "Spedizione moto", to: "/spedizione-moto" }, { label: "Deposito", to: "/servizi" },
            { label: "Autoscala", to: "/servizi" }, { label: "Aziende", to: "/servizi" },
          ]} />
          <Col title="Assistenza" links={[
            { label: "Richiedi preventivo", onClick: () => openQuote() },
            { label: "WhatsApp", href: waLink() }, { label: "Contatti", to: "/contatti" }, { label: "FAQ", to: "/contatti" },
          ]} />
          <Col title="Azienda" links={[
            { label: "Chi siamo", to: "/azienda" }, { label: "Recensioni", to: "/recensioni" },
            { label: "Lavora con noi", to: "/contatti" }, { label: "Privacy", to: "/contatti" }, { label: "Cookie", to: "/contatti" },
          ]} />
          <div className="col-span-2 md:col-span-1">
            <h4 className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#FF5A00] mb-4">Contatti</h4>
            <ul className="space-y-3 [&_svg]:shrink-0">
              <li><a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-2.5 text-zinc-400 hover:text-white transition-colors text-[15px]"><Phone size={16} /> {CONTACT.phoneDisplay}</a></li>
              <li><a href={`tel:${CONTACT.landlineRaw}`} data-testid="footer-landline" className="flex items-center gap-2.5 text-zinc-400 hover:text-white transition-colors text-[15px]"><Phone size={16} /> {CONTACT.landlineDisplay}</a></li>
              <li><a href={waLink()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-zinc-400 hover:text-white transition-colors text-[15px]"><WhatsAppIcon size={16} /> WhatsApp</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2.5 text-zinc-400 hover:text-white transition-colors text-[15px]"><Mail size={16} /> {CONTACT.email}</a></li>
              <li className="flex items-center gap-2.5 text-zinc-400 text-[15px]"><MapPin size={16} /> Roma, Italia</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-zinc-500 text-sm">© {new Date().getFullYear()} AXAL Logistics SRL — Tutti i diritti riservati</p>
          <p className="text-zinc-600 text-xs">P.IVA 17118681000</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
